export default __webpack_public_path__ + "static/avatar-tag-do-dark-e68fb07fc1123d8c859176c27b08d23eba444c04a26d1cdf6ae1b1e9ba77ae9d.png";